var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.78809 6.18672C4.78809 5.0722 5.70772 4.1687 6.84214 4.1687H26.7991C27.9335 4.1687 28.8532 5.0722 28.8532 6.18672V20.65C28.8532 21.7645 27.9335 22.668 26.7991 22.668H10.6116L6.29087 26.913C6.0391 27.1603 5.66046 27.2343 5.33152 27.1004C5.00257 26.9666 4.78809 26.6512 4.78809 26.3014V6.18672ZM6.84214 5.89843C6.68008 5.89843 6.5487 6.0275 6.5487 6.18672V24.2134L9.53855 21.2761C9.75867 21.0598 10.0572 20.9383 10.3685 20.9383H26.7991C26.9612 20.9383 27.0925 20.8092 27.0925 20.65V6.18672C27.0925 6.0275 26.9612 5.89843 26.7991 5.89843H6.84214Z",
  fill: "current"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.5609 12.4416H11.7603V10.7119H21.5609V12.4416Z",
  fill: "current"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.5609 16.2051H11.7603V14.4753H21.5609V16.2051Z",
  fill: "current"
});

function SvgSendMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/SendMessage.96987820.svg";
export { ForwardRef as ReactComponent };